export class LevelOfFrench {

    valeur: string;

}
